import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '@cfp/ui';

@Injectable()
export class NabersApiUnavailableInterceptor implements HttpInterceptor {
  private readonly alertService = inject(AlertService);
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (
          errorResponse.status === 503 &&
          errorResponse.error &&
          errorResponse.error.code === 'NABERS_API_UNAVAILABLE'
        ) {
          this.alertService
            .showAlert(
              'warning',
              'nabers.calculation.unavailable.error.title',
              'nabers.calculation.unavailable.error.body'
            )
            // force a window reload to make sure there are no disabled fields or components in 'loading' state.
            .subscribe(() => window.location.reload());
          return EMPTY;
        }
        return throwError(() => errorResponse);
      })
    );
  }
}
